/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React from "react";

import mfPlatforms from "../../config/mfPlatforms";

const InvestModal = ({
  open,
  onClose,
  fund,
}) => {

  if (!open) return null;

  // =====================================================
  // REDIRECT
  // =====================================================

  const handleRedirect = (platform) => {

    // ============================================
    // Later:
    // Add ARN/EUIN/tracking params
    // ============================================

    const url =
      `${platform.invest_url}`;

    window.open(
      url,
      "_blank"
    );
  };

  return (

    <div
      className="
        fixed
        inset-0
        bg-black/50
        backdrop-blur-sm
        z-[9999]
        flex
        items-center
        justify-center
        p-4
      "
    >

      <div
        className="
          bg-white
          w-full
          max-w-3xl
          rounded-[32px]
          overflow-hidden
          shadow-2xl
        "
      >

        {/* HEADER */}

        <div
          className="
            bg-gradient-to-r
            from-green-900
            to-green-700
            p-8
            text-white
          "
        >

          <div
            className="
              flex
              justify-between
              items-start
            "
          >

            <div>

              <div
                className="
                  text-2xl
                  font-black
                  mb-2
                "
              >
                Invest in Fund
              </div>

              <div
                className="
                  text-cyan-400
                  text-2xl
                  font-bold
                "
              >
                {fund?.canonical_name}
              </div>

            </div>

          <button
            onClick={onClose}
            className="
              text-white
              text-3xl
              font-light
              hover:opacity-70
              transition-all
              bg-transparent
              border-none
              outline-none
              shadow-none
              p-0
              w-auto
              h-auto
              leading-none
            "
          >
            X
          </button>


          </div>

        </div>

        {/* BODY */}

        <div className="p-8">

          <div
            className="
              text-gray-500
              mb-8
            "
          >
            Select your preferred
            investment platform
          </div>

          <div
            className="
              grid
              md:grid-cols-2
              gap-5
            "
          >

            {mfPlatforms.map((platform) => (

              <button
                key={platform.id}
                onClick={() =>
                  handleRedirect(platform)
                }
                className="
                  border
                  border-gray-200
                  rounded-2xl
                  p-5
                  hover:border-green-500
                  hover:shadow-lg
                  transition-all
                  text-left
                  bg-white
                "
              >

                <div
                  className="
                    flex
                    items-center
                    justify-between
                  "
                >

                  <div>

                    <div
                      className={`
                        ${platform.textColor}
                        text-2xl
                        font-extrabold
                        tracking-tight
                      `}
                    >
                      {platform.name}
                    </div>

                    <div
                      className="
                        text-gray-500
                        text-sm
                      "
                    >
                      Invest securely
                    </div>

                  </div>

                <div
                  className={`
                    w-14
                    h-14
                    rounded-2xl
                    bg-gradient-to-br
                    ${platform.gradient}
                    flex
                    items-center
                    justify-center
                    text-white
                    text-xl
                    font-black
                    shadow-lg
                  `}
                >
                  {platform.short}
                </div>

                </div>

              </button>

            ))}

          </div>

          {/* FOOTER */}

          <div
            className="
              mt-10
              p-5
              rounded-2xl
              bg-green-50
              border
              border-green-100
            "
          >

            <div
              className="
                text-sm
                text-green-900
                leading-7
              "
            >
              Distributor ARN:
              <span className="font-bold">
                {" "}ARN-356349
              </span>

              <br />

              EUIN:
              <span className="font-bold">
                {" "}EUIN-E680000
              </span>

              <br />

              Orion Analytics acts as
              an Authorised Mutual Fund Distributor.
            </div>

          </div>

        </div>

      </div>

    </div>

  );
};

export default InvestModal;